import * as React from 'react';

import ImageModalCharge from '@/assets/images/guide/img_modal_charge@2x.png';
import ImageNavCharge from '@/assets/images/guide/img_nav_charge@2x.png';
import { SpBr } from '@/components/layouts/Modal/Guest/style';

import { Container, ImageSupplement } from './style';
export interface ChargeCreditProps {}

const ChargeCreditContent: React.FC<ChargeCreditProps> = () => {
  return (
    <Container>
      <h2>かんたんチャージ</h2>
      <p>
        ナビ上の「チャージ」ボタンを押すとチャージ
        <SpBr />
        画面が表示されます。
      </p>
      <img src={ImageNavCharge} alt="navcharge" />
      <p>
        金額を入力または選択して「チャージする」ボ
        <SpBr />
        タンを押します。
      </p>
      <img src={ImageModalCharge} alt="modalcharge" />
      <ImageSupplement>
        <p>※クレジットカードでチャージする場合</p>
      </ImageSupplement>
    </Container>
  );
};

export default ChargeCreditContent;
